'use strict';

angular.module('mobile-apps').factory('MobileAppSubscription', ['$resource',
    function($resource) {
        return $resource(
            'v1/projects/:mobileAppId/subscription',
            {
                mobileAppId: '@_id'
            },
            {
                get:
                {
                    method:'GET',
                    cache: false
                }
            }
        );
    }
]);
